/**
 * Test IDs for QA automation.
 */
export const testIds = {
  forecastingNotificationsAlertsView: "forecasting-notifications-alerts-view",
  forecastingNotificationsAlertsWarning: "forecasting-notifications-alerts-warning",
} as const;
